import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { compose, graphql, withApollo } from 'react-apollo';
import { login, refreshAccessToken } from './schema/auth-schema.graphql';
import Auth from './Auth';

const { Consumer, Provider } = React.createContext({});

export const AuthConsumer = Consumer;

class AuthContextProvider extends React.Component {
  refreshTimerId = 0;

  constructor(props) {
    super(props);
    const userSession = Auth.getUserSession();
    this.state = {
      user: userSession,
      isAuthorized: Auth.isAuthorized,
      login: this.login,
      logout: this.logout,
    };
    Auth.addSessionChangeListener(this.onSessionChange);
    if (userSession) {
      this.setTokenRefresh(userSession.expiresAt);
    }
  }

  setTokenRefresh(expiresAt) {
    clearTimeout(this.refreshTimerId);
    const { refreshAccessToken } = this.props;
    try {
      const timeout = moment(expiresAt)
        .subtract(10, 'minutes')
        .diff(moment(), 'millisecond');
      this.refreshTimerId = setTimeout(async () => {
        const { data } = await refreshAccessToken();
        if (data.token) {
          Auth.setSession(data.token.access_token);
        }
      }, timeout);
    } catch (error) {
      console.error('Could not refresh access token');
    }
  }

  componentWillUnmount() {
    Auth.removeSessionListener(this.onSessionChange);
  }

  login = async (email, password) => {
    const { login } = this.props;
    try {
      const { data } = await login({ variables: { email, password } });

      if (data.login) {
        const user = Auth.setSession(data.login.access_token);
        this.setState({
          user,
        });
      }
    } catch (error) {
      let graphqlError = error.graphQLErrors[0].message;
      let errorMessage = graphqlError;

      if (graphqlError.includes('invalid_grant')) {
        errorMessage = 'Ung\u00fcltiger Benutzername oder Passwort';
      } else if (graphqlError.includes('Access denied')) {
        errorMessage = 'Zugriff verweigert';
      }
      throw new Error(errorMessage);
    }
  };

  logout = () => {
    const { client } = this.props;
    clearTimeout(this.refreshTimerId);
    client.resetStore();
    Auth.removeSessionListener(this.onSessionChange);
    Auth.clearSession();
    this.setState({ user: null });
  };

  onSessionChange = user => {
    if (!user) {
      this.logout();
    } else {
      this.setState({ user });
      this.setTokenRefresh(user.expiresAt);
    }
  };
  render() {
    const { children } = this.props;
    return <Provider value={this.state}>{children}</Provider>;
  }
}

AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const enhance = compose(
  graphql(login, { name: 'login' }),
  graphql(refreshAccessToken, { name: 'refreshAccessToken' }),
  withApollo
);
export const AuthProvider = enhance(AuthContextProvider);

export const withAuth = Component => props => (
  <Consumer>{authProps => <Component {...authProps} {...props} />}</Consumer>
);



// WEBPACK FOOTER //
// ./src/auth/AuthContext.jsx